// extracted by mini-css-extract-plugin
export default {"carrierPlanCapacityForm":"CarrierPlanCapacityForm_carrierPlanCapacityForm__ij-AE"};